<template>
  <div>
    <label>
      {{ index }}.
      {{ question }}
    </label>
    <b-link v-if="questionPlan" class="d-flex mb-3" @click="showModal">
      <i class="material-icons align-self-center small mx-1">
        flag
      </i>
      Click to see your plan
    </b-link>
    <b-form-radio-group
      v-model="selected"
      :options="sortedOptions"
      class="h-auto d-grid custom-radio"
      :required="required"
      @change="setHideQuestions"
    />
    <div v-for="item in sortedOptions" :key="item.value">
      <span v-if="selected == item.value && item.need_extra_data">
        <b-form-input
          v-if="item.need_extra_data"
          class="my-2"
          v-model="inputExtraData"
          placeholder="Enter your answer"
          :required="required"
          @change="() => setHideQuestions(selected, inputExtraData)"
        ></b-form-input>
      </span>
    </div>
    <modal :Gid="id" :planAnswers="getRelatedPlanAnswers" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import mixinListenerChangeElement from '@/mixins/listenerChangeElement';
import modal from '@/components/practice/modalQuestionPlan.vue';

export default {
  components: {
    modal,
  },
  props: {
    options: Array,
    question: String,
    index: Number,
    id: Number,
    answers: Array,
    questionPlan: Number,
    required: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixinListenerChangeElement],
  computed: {
    ...mapGetters('planning', ['getRelatedPlanAnswers']),
    ...mapGetters('user', ['getUserId']),
    sortedOptions() {
      const options = this.options;
      return options ? [...options].sort((a, b) => this.comparator(a, b)) : [];
    },
  },
  data() {
    return {
      selected: null,
      inputExtraData: null,
      hideQuestions: [],
      modalQuestion: false,
    };
  },
  methods: {
    ...mapActions('planning', ['FetchRelatedPlanAnswers']),
    setHideQuestions(selected, extraData) {
      this.hideQuestions.forEach((element) => {
        let idx = this.$parent.hideQuestions.indexOf(element);
        if (idx > -1) {
          this.$parent.hideQuestions.splice(idx, 1);
        }
      });
      this.hideQuestions = [];
      this.options.forEach((element) => {
        if (element.id == this.selected && element.skip_questions) {
          element.excluded_questions.forEach((item) => {
            this.hideQuestions.push(item.question_to_skip);
            this.$parent.hideQuestions.push(item.question_to_skip);
          });
        }
      });
      this.handleChangeElement({ id: this.id, value: selected, extraData: extraData });
    },
    showModal() {
      this.FetchRelatedPlanAnswers({
        parent: this.getUserId,
        questions: [this.questionPlan],
      }).then((response) => {
        this.modalQuestion = true;
        console.log('Response', response);
      });
    },

    comparator(a, b) {
      if (a.option_value < b.option_value || a.value < b.value) {
        return -1;
      }
      if (a.option_value > b.option_value || a.value > b.value) {
        return 1;
      }
      return 0;
    },
  },
  mounted() {
    if (this.answers != null && this.answers.length != 0) {
      this.answers.forEach((element) => {
        this.selected = element.option_id;
        if ('answer_text_1' in element) {
          this.inputExtraData = element.answer_text_1;
        }
      });
    }
  },
};
</script>
<style lang="scss">
.custom-radio {
  label {
    span {
      font-weight: 400;
    }
  }
}
</style>
